import { connect } from 'react-redux';
import * as TodoActions from '../actions';
import { bindActionCreators } from 'redux';
import MainSection from '../components/MainSection';
import { getTodos, getCompletedTodoCount } from '../selectors';

const mapStateToProps = state => ({
	todosCount: getTodos(state).length,
	completedCount: getCompletedTodoCount(state)
});

const mapDispatchToProps = dispatch => ({
	actions: bindActionCreators(TodoActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(MainSection);



// WEBPACK FOOTER //
// ./src/containers/MainSection.js